import React, { useEffect } from 'react';
import { HeroSection } from './components/sections/HeroSection';
import { StatsSection } from './components/sections/StatsSection';
import { IntroSection } from './components/sections/IntroSection';
import { GallerySection } from './components/sections/GallerySection';
import { VolumesSection } from './components/sections/VolumesSection';
import { BonusesSection } from './components/sections/BonusesSection';
import { OfferSection } from './components/sections/OfferSection';
import { ComparisonSection } from './components/sections/ComparisonSection';
import { TestimonialsSection } from './components/sections/TestimonialsSection';
import { FaqSection } from './components/sections/FaqSection';
import { FinalCtaSection } from './components/sections/FinalCtaSection';
import { SiteFooter } from './components/SiteFooter';
import { PurchasePopup } from './components/PurchasePopup';
import { initMetaPixel, PIXEL_ID } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen w-full bg-cream font-sans text-ink antialiased" data-id="element-0" data-mp="3ijpd910hgz9r">
      <noscript data-id="element-1" data-mp="3mk83iqmq9x9u">
        <img height="1" width="1" style={{
        display: 'none'
      }} alt="" src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} data-id="element-2" data-mp="3mjq45l4rr2xp" />
      </noscript>
      <HeroSection data-id="element-3" data-mp="4n5i12o8na1" />
      <main data-id="element-4" data-mp="56m9egl55mh">
        <StatsSection data-id="element-5" data-mp="7su7f7e1n58" />
        <IntroSection data-id="element-6" data-mp="2zld2jatxbhc2" />
        <GallerySection data-id="element-7" data-mp="2zm4y4lnitf2c" />
        <VolumesSection data-id="element-8" data-mp="2zmo5x9jgin2n" />
        <BonusesSection data-id="element-9" data-mp="2zng32ospcsv1" />
        <OfferSection data-id="element-10" data-mp="33m5b01uz1i7a" />
        <ComparisonSection data-id="element-11" data-mp="33nq5jrhad155" />
        <TestimonialsSection data-id="element-12" data-mp="33myl9ct52pu6" />
        <FaqSection data-id="element-13" data-mp="38lrrqla0dgku" />
        <FinalCtaSection data-id="element-14" data-mp="38li95irambp6" />
      </main>
      <SiteFooter data-id="element-15" data-mp="38kgkucl9nspi" />
      <PurchasePopup data-id="element-16" data-mp="38o4h3ji3it7x" />
    </div>;
}